import { Box } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatTemperature } from '../../util/formatters'
import { LineChart } from '../common/charts/LineChart'
import type { TemperatureCurveRow } from './TemperatureCurveDialog'

type Props = {
  table: Omit<TemperatureCurveRow, 'rowId'>[]
}

export function TemperatureCurveChart({ table }: Props): React.ReactElement {
  const { t } = useTranslation()

  const inSerie = {
    id: t('temperatureCurve.dialog.inTemperature'),
    data: table.map((row) => ({ x: row.outdoor, y: row.in })),
  }

  const outSerie = {
    id: t('temperatureCurve.dialog.returnTemperature'),
    data: table.map((row) => ({ x: row.outdoor, y: row.return })),
  }
  const series = [inSerie, outSerie]

  return (
    <Box
      height="350px"
      width="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <LineChart
        data={series}
        xFormatter={formatTemperature}
        yFormatter={formatTemperature}
        xAxisFormatter={formatTemperature}
        alignLegends="center"
      />
    </Box>
  )
}
